@if (!authenticationRequest && !error) {
    <ap-sign-skeleton></ap-sign-skeleton>
}
<div class="ap-sign">
    @if (authenticationRequest && showWysiwys()) {
        <ap-wysiwys [transactions]="authenticationRequest.transaction"></ap-wysiwys>
        @if (cancelText()) {
            <ap-button data-bb="cancel" variant="edit" (onClick)="onCancel()">
                {{ cancelText() }}
            </ap-button>
        }
    }

    @if (authenticationRequest && showWysiwys()) {
        <h2 class="secondary" data-bb="sign.title">
            @if (selectedToken) {
                <ap-content [key]="'sign.title.' + selectedToken"></ap-content>
            }
            @if (!selectedToken) {
                <ap-content key="sign.title"></ap-content>
            }
        </h2>
    }

    @if (error) {
        <ap-notification [status]="error.type">
            <span class="ap-sign__debugger">{{ browserCodeError }}</span>
            <span [innerHTML]="error | apSignError: selectedToken || tokenToSelect"> </span>
        </ap-notification>
    }

    @if (tokenTypes) {
        @if (isTokenSelectorSelected() && !hasAuthenticatedToken && !isAnonymous()) {
            <ap-notification type="info">
                <ap-content key="sign.select.explanation"></ap-content>
            </ap-notification>
        }
        @if (isLoading(null)) {
            <ap-token-selector-skeleton
                [hasRememberControl]="!!rememberControl()"
                [tokenTypesLength]="tokenTypes.length"
            ></ap-token-selector-skeleton>
        }
        @if (isTokenSelectorSelected()) {
            <ap-token-selector [tokenTypes]="tokenTypes" [rememberControl]="rememberControl()" (tokenSelected)="updateToken($event)">
                <ng-content></ng-content>
            </ap-token-selector>
        }
    }

    @if (isLoading(signToken.DIGICODE)) {
        <ap-digicode-skeleton></ap-digicode-skeleton>
    }
    @if (isSelected(signToken.DIGICODE)) {
        <ap-digicode
            [authenticationRequest]="authenticationRequest"
            [actionId]="actionId()"
            [ariaDescribedByIds]="ariaDescribedByIds()"
            [cancelText]="secondaryCancelText()"
            [submitText]="submitText()"
            [keyId]="keyId"
            [isProspect]="false"
            [saveTokenIdKey]="saveTokenIdKey()"
            (canceled)="onTokenCanceled()"
            (done)="onDone()"
            (signError)="onError($event)"
            (restart)="onRestart($event)"
            (retry)="onRetry($event)"
            (updatePassword)="onUpdatePassword($event)"
            (updateUsernamePassword)="onUpdateUsernamePassword($event)"
        ></ap-digicode>
    }

    @if (isLoading(signToken.PROSPECT_DIGICODE)) {
        <ap-digicode-skeleton></ap-digicode-skeleton>
    }
    @if (isSelected(signToken.PROSPECT_DIGICODE)) {
        <ap-digicode
            [authenticationRequest]="authenticationRequest"
            [actionId]="actionId()"
            [ariaDescribedByIds]="ariaDescribedByIds()"
            [cancelText]="secondaryCancelText()"
            [submitText]="submitText()"
            [keyId]="keyId"
            [isProspect]="true"
            (canceled)="onTokenCanceled()"
            (done)="onDone()"
            (signError)="onError($event)"
            (restart)="onRestart($event)"
            (retry)="onRetry($event)"
            (updatePassword)="onUpdatePassword($event)"
            (updateUsernamePassword)="onUpdateUsernamePassword($event)"
        ></ap-digicode>
    }

    @if (isLoading(signToken.DIGIPAS)) {
        <ap-digipas-skeleton [anonymous]="isAnonymous()"></ap-digipas-skeleton>
    }
    @if (isSelected(signToken.DIGIPAS)) {
        <ap-digipas
            [actionId]="actionId()"
            [authenticationRequest]="authenticationRequest"
            [ariaDescribedByIds]="ariaDescribedByIds()"
            [cancelText]="secondaryCancelText()"
            [submitText]="submitText()"
            [keyId]="keyId"
            [saveTokenIdKey]="saveTokenIdKey()"
            (canceled)="onTokenCanceled()"
            (done)="onDone()"
            (signError)="onError($event)"
            (restart)="onRestart($event)"
            (retry)="onRetry($event)"
        ></ap-digipas>
    }

    @if (isLoading(signToken.NATIVE_APP)) {
        <ap-native-app-skeleton></ap-native-app-skeleton>
    }
    @if (isSelected(signToken.NATIVE_APP)) {
        <ap-native-app
            [actionId]="actionId()"
            [initialStatus]="initialStatus"
            [cancelText]="secondaryCancelText()"
            (canceled)="onTokenCanceled()"
            (done)="onDone()"
            (signError)="onError($event)"
            (retry)="onRetry()"
        ></ap-native-app>
    }

    @if (isLoading(signToken.BROWSER)) {
        <ap-browser-skeleton></ap-browser-skeleton>
    }
    @if (isSelected(signToken.BROWSER)) {
        <ap-browser
            [authenticationRequest]="authenticationRequest"
            [cancelText]="secondaryCancelText()"
            [submitText]="submitText()"
            [keyId]="keyId"
            [actionId]="actionId()"
            [showLostCredentials]="showLostCredentials()"
            [anonymous]="isAnonymous()"
            [allowPendingTokens]="allowPendingTokens()"
            [implicitSigning]="implicitSigning()"
            (canceled)="onTokenCanceled()"
            (done)="onDone()"
            (signError)="onError($event)"
            (restart)="onRestart($event)"
            (retry)="onRetry($event)"
            (signedWithPendingToken)="onSignedWithPendingToken($event)"
            (signedWithInvalidCredentials)="onBrowserInvalidCredentials($event)"
            (lostCredentials)="onBrowserLostCredentials($event)"
        ></ap-browser>
    }

    @if (isLoading(signToken.PHONE_NUMBER)) {
        <ap-sign-phone-number-skeleton></ap-sign-phone-number-skeleton>
    }
    @if (isSelected(signToken.PHONE_NUMBER)) {
        <ap-sign-phone-number
            [authenticationRequest]="authenticationRequest"
            [anonymous]="!hasAuthenticatedToken"
            [submitText]="submitText()"
            [cancelText]="secondaryCancelText()"
            [actionId]="actionId()"
            [keyId]="keyId"
            (canceled)="onTokenCanceled()"
            (done)="onDone()"
            (signError)="onError($event)"
            (restart)="onRestart($event)"
            (retry)="onRetry($event)"
        ></ap-sign-phone-number>
    }

    <div>
        @if (canDeselectToken()) {
            <ap-button [text]="true" data-bb="deselectToken" (onClick)="updateToken(null)">
                {{ 'sign.back' | apContent }}
            </ap-button>
        }
    </div>
</div>
